import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPayments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/payments', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSinglePayment(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/payments/${data.id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatePayment(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/payments/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
